export interface MantenimientoPagingRes {
    count: number;
    next: null;
    previous: null;
    numero_paginas: number;
    data: Mantenimiento[];
}

export interface Mantenimiento {
    id_mantenimiento_activo?:string;
    codigo?: string;
    numero_referencia?: string;
    fecha_inicio?: string;
    fecha_fin?: string;
    costo: string;
    estado: boolean;
    activo: string;
    encargado: string;
    activo_data: any;
}

export enum FechasRango{
    HOY='HOY',
    MES_ACTUAL='MES ACTUAL',
    MESA_NTERIOR='MES ANTERIOR',
    ANIO_ACTUAL='AÑO ACTUAL',
    ANIO_ANTERIOR='AÑO ANTERIOR',
}